import React from "react";
import { BrowserRouter as Router } from "react-router-dom";
import Routes from "../Routes/Routes";
import { I18nextProvider } from "react-i18next";
import i18n from "../../i18n";
import { ThemeProvider } from "@material-ui/core/styles";
import theme from "../../styles/theme";
import Header from "../Header/Header";
import { CssBaseline, Box } from "@material-ui/core";
import { SWRConfig } from "swr";
import { SWROptions } from "../../utils/api";
import ErrorBoundary from "../ErrorBoundary";
import { ProvideAuth } from "../../utils/use-auth";
import { ProvideMe } from "../../utils/use-me";
import UnreadAnnouncements from "../UnreadAnnouncements/UnreadAnnouncements";
import StopImpersonatingButton from "../../components/StopImpersonatingButton";
import CpiChanges from "../CpiChanges/CpiChanges";
import NotificationContainer from "../NotificationContainer/NotificationContainer";
import { ProvideNotifications } from "../../utils/use-notifications";
import AppContainer from "../AppContainer/AppContainer";
import ConfirmProfile from "../ConfirmProfile/ConfirmProfile";
import CookiesPopup from "../../components/CookiesPopup";
import Footer from "../Footer";
import PageTracker from "../Routes/PageTracker";

const App = () => {
  return (
    <I18nextProvider i18n={i18n}>
      <ThemeProvider theme={theme}>
        <SWRConfig value={SWROptions}>
          <CssBaseline />
          <Router>
            <ErrorBoundary>
              <ProvideNotifications>
                <ProvideAuth>
                  <ProvideMe>
                    <PageTracker />
                    <Box
                      minHeight="100vh"
                      display="flex"
                      flexDirection="column"
                    >
                      <Header />

                      <Box flex="1">
                        <AppContainer>
                          <ConfirmProfile />
                          <UnreadAnnouncements />
                          <CpiChanges />
                          <NotificationContainer />
                          <CookiesPopup />
                          <Routes />
                        </AppContainer>
                      </Box>

                      <Footer />
                      <StopImpersonatingButton />
                    </Box>
                  </ProvideMe>
                </ProvideAuth>
              </ProvideNotifications>
            </ErrorBoundary>
          </Router>
        </SWRConfig>
      </ThemeProvider>
    </I18nextProvider>
  );
};

export default App;
